import React, { useState, useEffect, useRef } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import { pdfjsDistVersion } from 'pdfjs-dist';

import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import BackdropModal from '../components/modals/backdrop_modal';



const PDFUploader = () => {

  // creating new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // pdf file onChange state
  const [pdfFile, setPdfFile]=useState(null);

  // pdf file error state
  const [pdfError, setPdfError]=useState('');

  
  const [open, setOpen] = useState(false);

  const handleClose = () => {
      setOpen(false);
  };


  // handle file onChange event
  const allowedFiles = ['application/pdf'];
  const handleFile = (e) =>{
    let selectedFile = e.target.files[0];
    // console.log(selectedFile.type);
    if(selectedFile){
      if(selectedFile&&allowedFiles.includes(selectedFile.type)){
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onloadend=(e)=>{
          setPdfError('');
          setPdfFile(e.target.result);
        }
        setOpen(true);
      }
      else{
        setPdfError('Not a valid pdf: Please select only PDF');
        setPdfFile('');
      }
    }
    else{
      console.log('please select a PDF');
    }
  }

  const fileInputRef = useRef(null); // Create a ref for the file input

 

  const handleClick = () => {
    fileInputRef.current.click();
  };


  return (
    <div className="col mb-4">
        <div className="card " >
            <div className="card-body">
            <form>
              <input type='file' className="form-control  d-none" ref={fileInputRef} onChange={handleFile} />
              {pdfError&&<span className='text-danger'>{pdfError}</span>}
            </form>

           
 
            <div className="card-body  p-0 mb-2">
                <button className="btn btn-primary w-100 mb-2" type="button" onClick={handleClick} >
                  {pdfFile ? 'Re-upload PDF Documents' : 'Upload PDF Documents'}
                </button>
  
              {pdfFile &&
                  <button className="btn btn-primary w-100 mb-2" type="button" onClick={()=>setOpen(true)} >
                    View Uploaded PDF
                  </button>
                  }

            </div>


          {pdfFile &&
            <BackdropModal open={open} handleClose={handleClose} modalTitle="Uploaded Documents" >
              <Worker workerUrl="../js/pdf.worker.min.js">
                <Viewer fileUrl={pdfFile}
                  plugins={[defaultLayoutPluginInstance]}></Viewer>
              </Worker>
            </BackdropModal>
          }
   

            
                    {!pdfFile&&<>No file is selected yet</>}
            </div>
        </div>
    </div>
  );
};

export default PDFUploader;
